import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  ReffererId: "",
};

const useSlice = createSlice({
  name: "referer",
  initialState,
  reducers: {
    updateReferrerId(state, action) {
    
      state.ReffererId = action.payload.ReffererId; 
     
    },
  },
});

export const { updateReferrerId } = useSlice.actions;
export default useSlice.reducer;